// AGC: Auto-closing battle result modal component

// AGC: Shows battle result and auto-closes after 5 seconds

import React, { useEffect, useState } from 'react'

import { playSoundSafe } from '../../utils/audio'



interface BattleResultModalProps {

  isOpen: boolean

  won: boolean

  isDraw?: boolean

  onClose: () => void

  autoCloseDelay?: number // AGC: Milliseconds before auto-close (default 5000)

}



export const BattleResultModal: React.FC<BattleResultModalProps> = ({

  isOpen,

  won,

  isDraw = false,

  onClose,

  autoCloseDelay = 5000

}) => {

  const [timeLeft, setTimeLeft] = useState(autoCloseDelay / 1000)



  useEffect(() => {

    if (!isOpen) {

      return

    }



    const audioSource = isDraw ? '/sounds/punch.mp3' : won ? '/sounds/youwin.mp3' : '/sounds/gameover.mp3'

    playSoundSafe(audioSource, isDraw ? 0.4 : won ? 0.75 : 0.65)

  }, [isOpen, isDraw, won])



  useEffect(() => {

    if (!isOpen) {

      // AGC: Reset timer when modal closes

      setTimeLeft(autoCloseDelay / 1000)

      return

    }



    console.log(' Modal opened, starting', autoCloseDelay / 1000, 'second timer')

    

    // AGC: Reset timer when modal opens

    setTimeLeft(autoCloseDelay / 1000)



    // AGC: Countdown timer (updates every second)

    const countdownInterval = setInterval(() => {

      setTimeLeft((prev) => {

        const newTime = prev - 1

        console.log('[TIMER] Time left:', newTime, 'seconds')

        if (newTime <= 0) {

          clearInterval(countdownInterval)

          return 0

        }

        return newTime

      })

    }, 1000)



    // AGC: Auto-close timer

    const autoCloseTimer = setTimeout(() => {

      console.log(' Battle result modal auto-closing NOW')

      onClose()

    }, autoCloseDelay)



    // AGC: Cleanup timers on unmount or close

    return () => {

      console.log(' Cleaning up modal timers')

      clearInterval(countdownInterval)

      clearTimeout(autoCloseTimer)

    }

  }, [isOpen]) // AGC: Only depend on isOpen, not onClose or autoCloseDelay



  if (!isOpen) return null



  // AGC: Determine title, emoji, and colors

  let title = ''

  let emoji = ''

  let bgGradient = ''

  let textColor = ''



  if (isDraw) {

    title = 'DRAW!'

    emoji = ''

    bgGradient = 'from-gray-600 to-gray-700'

    textColor = 'text-gray-200'

  } else if (won) {

    title = 'VICTORY!'

    emoji = ''

    bgGradient = 'from-yellow-500 to-orange-600'

    textColor = 'text-yellow-100'

  } else {

    title = 'DEFEAT'

    emoji = ''

    bgGradient = 'from-red-600 to-purple-700'

    textColor = 'text-red-100'

  }



  // AGC: Determine border color based on result type

  const borderColor = isDraw ? 'border-blue-500' : won ? 'border-emerald-500' : 'border-red-500'

  return (

    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-fade-in">

      <div className={`bg-slate-900 border-2 ${borderColor} rounded-2xl shadow-2xl p-8 max-w-md w-full transform animate-scale-in`}>

        {/* AGC: Emoji */}

        <div className="text-center mb-4">

          <div className="text-9xl animate-bounce-slow">{emoji}</div>

        </div>



        {/* AGC: Title */}

        <h2 className={`text-4xl font-bold text-center mb-4 ${textColor} drop-shadow-lg`}>

          {title}

        </h2>



        {/* AGC: Auto-close countdown */}

        <div className="text-center mb-6">

          <div className={`text-sm ${textColor} opacity-75`}>

            Auto-closing in {timeLeft}s

          </div>

          <div className="w-full bg-white/20 rounded-full h-2 mt-2">

            <div

              className="bg-white h-2 rounded-full transition-all duration-1000 ease-linear"

              style={{ width: `${(timeLeft / (autoCloseDelay / 1000)) * 100}%` }}

            ></div>

          </div>

        </div>



        {/* AGC: Close button */}

        <button

          onClick={onClose}

          className={`w-full bg-white/20 hover:bg-white/30 ${textColor} font-bold py-3 px-6 rounded-lg transition-all transform hover:scale-105 backdrop-blur-sm`}

        >

          Close Now

        </button>



        {/* AGC: Small hint */}

        <div className={`text-center mt-3 text-xs ${textColor} opacity-60`}>

          Press ESC or click to close immediately

        </div>

      </div>



      {/* AGC: Keydown ESC to close */}

      <div

        className="absolute inset-0 -z-10"

        onClick={onClose}

        onKeyDown={(e) => {

          if (e.key === 'Escape') {

            onClose()

          }

        }}

        tabIndex={0}

      ></div>

    </div>

  )

}



// AGC: Custom animations for modal

const style = document.createElement('style')

style.textContent = `

  @keyframes fade-in {

    from { opacity: 0; }

    to { opacity: 1; }

  }

  

  @keyframes scale-in {

    from {

      opacity: 0;

      transform: scale(0.8);

    }

    to {

      opacity: 1;

      transform: scale(1);

    }

  }

  

  @keyframes bounce-slow {

    0%, 100% {

      transform: translateY(0);

    }

    50% {

      transform: translateY(-20px);

    }

  }

  

  .animate-fade-in {

    animation: fade-in 0.3s ease-out;

  }

  

  .animate-scale-in {

    animation: scale-in 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

  }

  

  .animate-bounce-slow {

    animation: bounce-slow 2s ease-in-out infinite;

  }

`

document.head.appendChild(style)


